import React from 'react';
import moment from 'moment';
import { FormattedMessage, useIntl } from 'react-intl';
import { QuestionnaireAnswerSC } from './questionnaires.styled';
import { getDateFormat } from '../../../../helpers/utils-helpers';

type TProps = {
  title: string;
  icon: React.ReactNode;
  answers: string[] | string;
  countries: {
    name: string;
    code: string;
  }[];
};

const isObject = (something: any) => something && something.constructor === Object;

const QuestionnaireAnswer: React.FC<TProps> = ({ title, icon, answers, countries }) => {
  const options = Array.isArray(answers) ? answers : [answers];
  const intl = useIntl();

  const formatObject = (key: string, value: any) => {
    const dict = [
      'post_covid_symptoms_rate_any',
      'post_covid_symptoms_rate_mild',
      'post_covid_symptoms_rate_severe',
      'post_covid_symptoms_rate_extreme',
    ];

    return `${intl.formatMessage({ id: key })}: ${intl.formatMessage({
      id: `questionnaire:${dict[value]}`,
    })}`;
  };

  const formatAnswer = (text: string | number | null) => {
    if (text === null) {
      return '-';
    }
    if (text.toString().includes('date:')) {
      // might get in format "date: date string;text:sfsf"
      const words = text.toString().replace('date:', '').replace('text:', '').split(';');
      return `${moment(words[0]).format(getDateFormat())} ${words[1]}`;
    }
    if (text.toString().includes('country:')) {
      // might get in format "country:SK"
      const country = text.toString().replace('country:', '');
      return countries.find((c) => c.code === country)?.name || country;
    }
    return text.toString().includes('questionnaire:') || text.toString().includes('common:') ? (
      <FormattedMessage id={text.toString()} />
    ) : (
      text
    );
  };

  return (
    <QuestionnaireAnswerSC>
      {title && (
        <div className="qa-title">
          <div className="qa-icon">{icon}</div>
          <h5>
            <FormattedMessage id={title} />
          </h5>
        </div>
      )}
      <div className="qa-options">
        {options.map((op) => {
          if (isObject(op)) {
            return Object.keys(op).map((key, i) => (
              <div className="qa-option" key={key}>
                <div className="qa-dot" />
                {formatObject(key, i)}
              </div>
            ));
            // return
          } else {
            return (
              <div className="qa-option" key={op}>
                <div className="qa-dot" />
                {formatAnswer(op)}
              </div>
            );
          }
        })}
      </div>
    </QuestionnaireAnswerSC>
  );
};

QuestionnaireAnswer.defaultProps = {
  countries: [],
};

export default QuestionnaireAnswer;
